export default __webpack_public_path__ + "static/media/passive-auth-en-dark.0ad4dacd.png";